module.exports = __webpack_public_path__ + "static/media/Yacht-Center-Group-01.6f0da0a3.jpg";